import { render, staticRenderFns } from "./PromotionFactors.vue?vue&type=template&id=a3c8abf4&"
import script from "./PromotionFactors.vue?vue&type=script&lang=js&"
export * from "./PromotionFactors.vue?vue&type=script&lang=js&"
import style0 from "./PromotionFactors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionFactors.vue"
export default component.exports